import Vue from 'vue'
import App from './app.vue'
import VueCookie from 'vue-cookie'

// Tell Vue to use the plugin
Vue.use(VueCookie);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
